// 2026-09-28 (Manak) — "Order changes waiting" tile on the Admin and Accounts
// home dashboards. Confirmed sales order edit/delete requests are decided on
// /approvals/order-changes; this tile makes the queue visible from home.
// Reads the same list the page reads (GET /sales-orders/change-requests).
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/utils/api';

export const ORDER_CHANGES_PATH = '/approvals/order-changes';

interface Kpis { waiting: number; over24h: number }

export function OrderChangesTile() {
  const [kpis, setKpis] = useState<Kpis | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let live = true;
    api
      .get('/sales-orders/change-requests', { params: { status: 'pending' } })
      .then((res: any) => {
        if (!live) return;
        const k = res?.data?.kpis;
        setKpis({ waiting: Number(k?.waiting ?? 0) || 0, over24h: Number(k?.over24h ?? 0) || 0 });
      })
      .catch(() => { if (live) setFailed(true); });
    return () => { live = false; };
  }, []);

  const urgent = (kpis?.waiting ?? 0) > 0;
  return (
    <Link
      to={ORDER_CHANGES_PATH}
      aria-label="Order changes waiting"
      className={`block min-w-0 rounded-xl border p-4 shadow-sm ${urgent ? 'border-amber-400 bg-amber-50' : 'bg-white'}`}
    >
      <span className="text-sm text-gray-600">Order changes waiting</span>
      {kpis && (
        <>
          <strong className="my-2 block text-3xl font-semibold tabular-nums">{kpis.waiting}</strong>
          <span className="block text-sm text-gray-600">
            {kpis.waiting === 0
              ? 'No sales order edit or delete requests'
              : kpis.over24h > 0
                ? `${kpis.over24h} waiting over 24 h · approve or reject`
                : 'Sales order edits and deletes · approve or reject'}
          </span>
        </>
      )}
      {!kpis && !failed && <span className="mt-2 block text-sm text-gray-400">Loading…</span>}
      {failed && <span className="mt-2 block text-sm text-gray-600">Open the list</span>}
    </Link>
  );
}

export default OrderChangesTile;
